module.exports = __webpack_public_path__ + "static/img/266_TO8_2354.7642f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/266_TO8_2354.jpg
// module id = 0XgY
// module chunks = 0